import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/contexts/AuthContext";
import { getNewestDraftId } from "@/hooks/use-mvp-persistence";

/** `/mvp` → najnowszy szkic lub `/mvp/new`. Obsługuje `?new=1` → `/mvp/new`. */
export default function MvpRootRedirect() {
  const navigate = useNavigate();
  const { user } = useAuth();

  useEffect(() => {
    try {
      const sp = new URLSearchParams(window.location.search);
      if (sp.get("new") === "1") {
        navigate("/mvp/new", { replace: true });
        return;
      }
    } catch {
      /* noop */
    }

    if (!user) {
      navigate("/mvp/new", { replace: true });
      return;
    }

    getNewestDraftId(user.id).then((newest) => {
      navigate(newest ? `/mvp/${newest}` : "/mvp/new", { replace: true });
    });
  }, [user, navigate]);

  return (
    <div className="flex min-h-screen items-center justify-center bg-background text-sm text-muted-foreground">
      Ładowanie…
    </div>
  );
}
